import { render } from "./ProjectsMain.vue?vue&type=template&id=e16d13b8"
import script from "./ProjectsMain.vue?vue&type=script&lang=js"
export * from "./ProjectsMain.vue?vue&type=script&lang=js"
script.render = render

export default script